import React, { useState } from "react";
import { Button, Drawer } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  toggleNewDialog,
  setSelectedRaw,
  emptySelectedRawMaterial,
} from "./store/stateSlice";
import { injectReducer } from "../../store";
import RawMaterialreducer from "./store";
import RawMaterialForm from "./components/RawMaterialForm";
import RawMaterialTable from "./components/RawMaterialTable";
import BomTable from "./components/BomTable";
injectReducer("rawMaterial", RawMaterialreducer);
const RawMaterial = () => {
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const dialog = useSelector((state) => state.rawMaterial.state.newDialog);
  const handleClose = () => {
    dispatch(toggleNewDialog(false)); // Close the modal
  };

  const onDialog = () => {
    dispatch(setSelectedRaw(null));
    dispatch(toggleNewDialog(true));
    dispatch(emptySelectedRawMaterial([]));
  };
  return (
    <>
      <div className="bg-white m-4 p-8 rounded-xl">
        <div className="flex justify-between mb-6">
          <div className="text-xl font-bold !text-[#414141]">Raw Material</div>
          <div className="flex">
            <div className="flex items-center">
              {/* <FormSearch /> */}
              <Button type="primary" onClick={onDialog}>
                Add Raw Material
              </Button>
              <Drawer
                title="Add Raw Material"
                onClose={handleClose}
                open={dialog}
                width={1500}
              >
                <RawMaterialForm type={"new"} />
              </Drawer>
            </div>
          </div>
        </div>

        <BomTable />
      </div>
    </>
  );
};

export default RawMaterial;
